export enum DealStatus {
  Cancelled = '989CC75C-CD70-4482-BD18-0591FA3D2F2F',
  Selection = '299EE95B-A733-45C9-B04B-10F01CE67C48',
  FinalSale = '44734B80-46C3-458C-948A-4FBFFD67FED2',
  ContractReady = '173F4025-4718-4A57-9F3F-5C70F9FF3225',
  PendingOffer = 'CCF17917-4F55-447B-8739-9708AEAD52E3',
  UnderContract = 'A1B2C3D4-E5F6-7890-ABCD-EF1234567890'
}

// DealStatus plus Send Email option
export enum DealStatusWithSendEmail {
  Cancelled = DealStatus.Cancelled,
  Selection = DealStatus.Selection,
  FinalSale = DealStatus.FinalSale,
  ContractReady = DealStatus.ContractReady,
  PendingOffer = DealStatus.PendingOffer,
  UnderContract = DealStatus.UnderContract,
  SendEmail = 'XXX-EMAIL-SENT-000', //some random id for if email is sent
  DealClosed = 'XXX-DEAL-CLOSED-000' //some random id for if deal is closed
}

export const DealStatusLabels: Record<DealStatus | DealStatusWithSendEmail, string> = {
  [DealStatus.Cancelled]: 'Cancelled',
  [DealStatus.Selection]: 'Selection',
  [DealStatus.FinalSale]: 'Deal Closed',
  [DealStatus.ContractReady]: 'Contract Ready',
  [DealStatus.PendingOffer]: 'Pending Offer',
  [DealStatus.UnderContract]: 'Under Contract',
  [DealStatusWithSendEmail.SendEmail]: 'Welcome Email',
  [DealStatusWithSendEmail.DealClosed]: 'Deal Closed'
};

export const DEAL_STATUS_TIMELINE_ORDER: readonly DealStatusWithSendEmail[] = [
  DealStatusWithSendEmail.Selection,
  DealStatusWithSendEmail.ContractReady,
  DealStatusWithSendEmail.PendingOffer,
  DealStatusWithSendEmail.SendEmail,
  DealStatusWithSendEmail.UnderContract,
  DealStatusWithSendEmail.FinalSale
];

export enum AddendumType {
  INI = 'INI',
  LOA = 'LOA'
}

export enum DocuSignStatus {
  Pending = 'Pending',
  Sent = 'Sent',
  Delivered = 'Delivered',
  Complete = 'Complete'
  // Voided = 'Voided',
  // Declined = 'Declined'
}
